import React, { useEffect, useState } from 'react'
import { Button, Form, Image, message, Popconfirm, Table, Tooltip, Popover, Modal, Input, Upload } from 'antd'
import { FaTrash } from 'react-icons/fa6'
import axios from 'axios'
import { SERVER_ADDRESS } from '../../Config/Config'
import { EditTwoTone, PlusCircleOutlined, UploadOutlined } from '@ant-design/icons'
const { TextArea } = Input;

const ViewHobbies = () => {
    const [data,setData] = useState([]);
    const [createModal,setCreateModal] = useState(false)
    const [fileList, setFileList] = useState([]);
    const [editModal, setEditModal] = useState(false);
    const [editingHobby, setEditingHobby] = useState(null);
    const [create] = Form.useForm();
    const [editForm] = Form.useForm();
    const userData = JSON.parse(atob(localStorage.getItem('token').split('.')[1]));
    const userPermission = userData.privelege || []
    const [createLoading,setCreateLoading] = useState(false);
    const [editLoading,setEditLoading] = useState(false);

    const handleCreateCancel = ()=>{
        setCreateModal(false)
        create.resetFields();
    }

    const handleEditHobby = (record) => {
        setEditingHobby(record);
        editForm.setFieldsValue(record)
        setEditModal(true);
    };

    const fetchHobby = async()=>{
        try {
            const response = await axios.get(`${SERVER_ADDRESS}/api/getHobby`);
            if(response.status === 200){
                setData(response.data.data)
            }
        } catch (error) {
            console.log(error)
            message.error({content:"Oops! Something Went Wrong"})
        }
    }

    useEffect(()=>{
        fetchHobby()
    },[])

    const handleDelete = async(id)=>{
        try {
            const response = await axios.post(`${SERVER_ADDRESS}/api/deleteHobby`,{id});
            if(response.status === 200){
                message.success({content:`${response.data.message}`})
                const updatedData = data.filter(item=>item.id !== id);
                setData(updatedData);
            }
        } catch (error) {
            message.error({content:"Oops! Something Went Wrong"})
        }
    }

    const columns = [
        {
            title:"Id",
            dataIndex:"id",
            key:"id",
            sorter:(a,b)=>a.id - b.id
        },
        {
            title:"Hobby Image",
            dataIndex:"images",
            key:"images",
            render:(_,record)=>(
                <Tooltip title='View' >
                    <Image src={record.images} width={30} />
                </Tooltip>
            )
        },
        {
            title:"Hobby Title",
            dataIndex:"hobby",
            key:"hobby",
            render: (text) => (
                <Popover content={text} title="Hobby" trigger="hover">
                  <span style={{textAlign:"center",width:"50%"}} >{text.length > 20 ? `${text.slice(0, 20)}...` : text}</span>
                </Popover>
              ),
        },
        {
            title:"Option",
            key:"option",
            render:(_,record)=>(
                <div className='d-flex flex-row gap-2' >
                    {userPermission.includes('edit') && (
                        <Tooltip title='Edit Hobby' >
                            <Button onClick={() => handleEditHobby(record)} variant='filled' color='blue' ><EditTwoTone /></Button>
                        </Tooltip>
                    ) }
                    {userPermission.includes('delete') && (
                        <Popconfirm title='Are You Sure Want to Delete Hobby ?' >
                            <Button onClick={() => handleDelete(record.id)} variant='filled' color='red'><FaTrash /></Button>
                        </Popconfirm>
                    ) }
                </div>
            )
        }
    ]

    const handleSubmit = async()=>{
        try {
            setEditLoading(true)
            const values = await create.validateFields();

            const formData = new FormData();
            formData.append('hobby',values.hobby);
            formData.append('image',fileList[0].originFileObj)

            const response  = await axios.post(`${SERVER_ADDRESS}/api/addHobby`,formData,{
                headers:{
                    'Content-Type':'multipart/form-data'
                }
            });

            if(response.status===200){
                if(response.data.result === 1){
                    create.resetFields();
                    setFileList([]);
                    handleCreateCancel();
                    fetchHobby();
                    setEditLoading(false)
                }
                else if(response.data.result === 0){
                    message.warning({content:`${response.data.message}`})
                    setEditLoading(false)
                }
            }

        } catch (error) {
            message.error({content:"Oops ! Something Went Wrong"})
            setCreateLoading(false)
        }
    }

    const handleEditSubmit = async()=>{
        try {
            setCreateLoading(true)
            const values = await editForm.validateFields()
            const formData = new FormData();
            formData.append('hobby',values.hobby)
            formData.append("id", editingHobby.id);
            formData.append('image',fileList[0].originFileObj)

            const response = await axios.post(`${SERVER_ADDRESS}/api/editHobby`,formData,{
                headers:{
                    'Content-Type':'multipart/form-data'
                }
            });

            if(response.status === 200){
                if(response.data.result === 1){
                    message.success({content:`${response.data.message}`})
                    editForm.resetFields();
                    setEditModal(false);
                    setEditingHobby(null);
                    setFileList([]);
                    fetchHobby();
                    setCreateLoading(false)
                }
                else if(response.data.result === 0){
                    setCreateLoading(false)
                    message.warning({content:`${response.data.message}`})
                }
            }

        } catch (error) {
            setCreateLoading(false)
            message.error({content:"Oops! Something Went Wrong"})
        }
    }

  return (
    <div style={{marginTop:"4rem"}}>
        <div style={{display:'flex',flexDirection:"row",justifyContent:"space-between"}} >
            <h3 className='my-3' >Hobby List</h3>
            <Button onClick={()=>setCreateModal(true)} className=' text-white' style={{backgroundColor:"#588157",border:"none"}} ><PlusCircleOutlined /> Add Hobby</Button>
        </div>
        <Table columns={columns} rowKey={'id'} dataSource={data} />
        <Modal open={createModal} footer={false} maskClosable={true} onCancel={()=>handleCreateCancel()} title='Add Hobby' >
            <Form form={create} >
                <Form.Item label='Hobby' name='hobby' rules={[{required:true,message:"Enter Hobby Title"}]} >
                    <TextArea rows={4} placeholder='Enter a Hobby' />
                </Form.Item>
                <Form.Item label='Image' name='images' rules={[{required:true,message:"Upload Hobby Image"}]} >
                    <Upload fileList={fileList} onChange={({ fileList }) => setFileList(fileList)} listType='picture-card' maxCount={1} beforeUpload={() => false} >Upload</Upload>
                </Form.Item>
                <Form.Item>
                    <Button loading={createLoading} type='primary' onClick={handleSubmit} >
                        <PlusCircleOutlined /> Create
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
        <Modal open={editModal} title="Edit Hobby" footer={false} onCancel={() => {
            setEditModal(false);
            setEditingHobby(null);
        }}
        >
        <Form
        form={editForm}
        onFinish={handleEditSubmit}        
        >
            <Form.Item
            name="hobby"
            label="Hobby Title"
            rules={[{ required: true, message: "Enter Hobby Title" }]}
            >
            <Input />
            </Form.Item>

            <Form.Item  name="image" label="Change Image" rules={[{required:true,message:"Image Required to update"}]} >
            <Upload
                listType="picture-card"
                maxCount={1}
                accept='.png,.svg,.jpeg'
                beforeUpload={() => false} // prevent auto upload
                fileList={fileList} onChange={({ fileList }) => setFileList(fileList)}
            >
                <UploadOutlined /> Upload
            </Upload>
            </Form.Item>

            <Form.Item>
            <Button loading={editLoading} type="primary" htmlType="submit">
                Update Hobby
            </Button>
            </Form.Item>
        </Form>
        </Modal>

    </div>
  )
}

export default ViewHobbies